interface IErrorProps {
  message: string;
  statusCode: number;
  errors: any;
}

class Error {
  public message;

  public statusCode;

  public errors;

  constructor({ message, statusCode, errors }: IErrorProps) {
    this.message = message || 'Възникна грешка. Опитайте отново по-късно, или ни пишете на support@ehr.bg';
    this.statusCode = statusCode;
    this.errors = errors;
  }
}

// Unifies the error when there is a response from the server
// and when there isn't (no internet or server doesn't respond).
// In situations when there is no response, a 'message' is still coming,
// provided invernally by the Axios middleware.
export const createErrorFromResponse = (response: any): IErrorProps => {
  if (!response) {
    return new Error({
      message: 'Проблем със сървъра на eHR. Проверете интернет връзката си или се свържете с нас на support@ehr.bg',
      // This is not really valid, as if there is no response at all from the BE, a CORS erros is thrown, so there is
      // no real 500 HTTP response code retuned.
      statusCode: 500,
      errors: null,
    });
  }

  // Extract commonErrors
  let commonErrors: string | null = null;
  if (response?.data?.errors_common) {
    const errorsCommonObj = response.data.errors_common;
    const errorMessages: string[] = [];
    // Iterate over all properties of errors_common to construct the error messages string
    Object.entries(errorsCommonObj).forEach(([key, value]) => {
      // Assuming each value is an array of string messages
      if (Array.isArray(value)) {
        errorMessages.push(value.join(', '));
      } else {
        // If it's not an array, just push it as a string
        errorMessages.push(value as string);
      }
    });
    commonErrors = errorMessages.join('\n');
  }
  if (response?.data?.errors) {
    const errorsCommonObj = response.data.errors;
    const errorMessages: string[] = [];
    // Iterate over all properties of errors to construct the error messages string
    Object.entries(errorsCommonObj).forEach(([key, value]) => {
      // Assuming each value is an array of string messages
      if (Array.isArray(value)) {
        errorMessages.push(value.join(', '));
      }
    });
    commonErrors = errorMessages.join('\n');
  }

  // Check server response for a message
  const prettyMessage = commonErrors || response?.data?.message || response?.message || 'Unknown error';

  // Extract statusCode
  const statusCode = response?.data?.status_code || response?.status || 500;

  const errors =
    statusCode >= 500
      ? '500+ Проблем във връзката със сървъра. Ако проблемът продължава свържете се с нас на support@ehr.bg.'
      : // check server response for any errors
        (response && response.data && response.data.errors) ||
        // if not - simply take the response as is
        (response && response.data) ||
        response;

  return new Error({
    message: prettyMessage,
    statusCode,
    errors,
  });
};

export default Error;
